/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { CircularProgress } from "@material-ui/core";
import Select from "react-select";
import cloneDeep from "lodash/cloneDeep";
import { toast } from "react-toastify";
import { getRequest, putRequest } from "utils/request";
import { i18n } from "../../../translate/i18n";

import "./style.css";

export default function UserCompany({ match, history }) {
  const [loading, setLoading] = useState(false);
  const [listCompanies, setListCompanies] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [active, setActive] = useState(true);
  const [userCompanies, setUserCompanies] = useState([]);
  const [user, setUser] = useState("");

  const getProfiles = async () => {
    setLoading(true);

    const ReturnGet = await getRequest(`/users/${match.params.id}`);
    if (ReturnGet.success) {
      setUser(ReturnGet.data);

      setActive(ReturnGet.data.active);

      if (ReturnGet.data.UserTypeId === 1) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }

      let returnedUserCompanies = ReturnGet.data.UserCompanies;
      let companiesID = [];
      returnedUserCompanies.forEach((userCompany) => {
        companiesID.push({
          value: userCompany?.CompanyId,
          label: userCompany?.Company?.nickName,
          CompanyId: userCompany?.Company?.id,
          CompanyDepartments: userCompany?.CompanyDepartments.map(
            (deparment) => ({
              ...deparment,
              value: deparment.id,
              label: deparment.description,
            })
          ),
        });
      });

      setUserCompanies(companiesID);
    }

    //BUSCA EMPRESAS DISPONIVEIS
    let ReturnGet2 = await getRequest(`/userscompanies/partners?includeOmni=0`);
    if (ReturnGet2.success) {
      let opt = [];
      ReturnGet2.data.forEach((company) => {
        opt.push({
          value: company.id,
          label: company.nickName,
          CompanyId: company.id,
          CompanyDepartments: company.CompanyDepartments.map((deparment) => ({
            ...deparment,
            value: deparment.id,
            label: deparment.description,
          })),
        });
      });
      setListCompanies(opt);
    }

    setLoading(false);
  };

  useEffect(() => {
    getProfiles();
  }, []);

  const handleConfirm = async () => {
    if (
      userCompanies.some((company) => company.CompanyDepartments.length === 0)
    ) {
      toast.error(i18n.t("notSelectedCompanyDepartmentError"));
      return;
    }

    setLoading(true);

    let finalUserCompanies = [];
    let userCompaniesDepartments = [];

    userCompanies.forEach((userCompany) => {
      userCompaniesDepartments = [];

      if (userCompany.CompanyId !== 0) {
        userCompany.CompanyDepartments.forEach((department) => {
          userCompaniesDepartments.push({
            CompanyDepartmentId: department.id,
          });
        });
      }

      finalUserCompanies.push({
        userId: user.id,
        CompanyId: userCompany.CompanyId,
        UserCompanyDepartments: userCompaniesDepartments,
      });
    });

    user.UserCompanies = finalUserCompanies;

    const ReturnPut = await putRequest(
      `/users/staff/${match.params.id}/userscompanies`,
      user
    );
    setLoading(true);
    if (ReturnPut.success) {
      history.goBack();
    }

    setLoading(false);
  };

  const handleChangeCompanies = (e) => {
    if (e) {
      const nextUserCompanies = e.map((uc) => {
        let userCompany = userCompanies.find(
          (element) => element.CompanyId === uc.CompanyId
        );

        if (userCompany) {
          return userCompany;
        } else {
          let companyCopy = cloneDeep(uc);
          let defaultDepartment = uc.CompanyDepartments.find(
            (department) => department.default
          );
          companyCopy.CompanyDepartments = [defaultDepartment];
          return companyCopy;
        }
      });

      setUserCompanies(nextUserCompanies);
    } else {
      setUserCompanies([]);
    }
  };

  const handleChangeDepartment = (e, companyId) => {
    const nextUserCompanies = userCompanies.map((userCompany) => {
      if (userCompany.CompanyId === companyId) {
        userCompany.CompanyDepartments = e || [];
      }

      return userCompany;
    });

    setUserCompanies(nextUserCompanies);
  };

  const getUserCompanyDepartments = (companyId) => {
    const userCompany = userCompanies.find((uc) => uc.CompanyId === companyId);
    if (!userCompany) return [];

    return userCompany.CompanyDepartments;
  };

  return (
    <div className="col-12" style={{ overflowY: "auto" }}>
      <div className="card">
        <div className="card-body pt-1">
          {!loading ? (
            <>
              <form
                className="form-edit"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleConfirm();
                }}
              >
                {user && (
                  <h3 className="header-title">{`Usuário: ${user.name}`}</h3>
                )}
                <div className="form-row col-md-3">
                  <h4 className="header-title">{i18n.t("company")}</h4>
                  <div className="form-group col-md-12">
                    <Select
                      options={listCompanies}
                      placeholder={`Seleciona as empresas`}
                      isMulti={true}
                      isDisabled={disabled || !active}
                      getStyles="select2 form-control select2-multiple"
                      value={userCompanies}
                      onChange={handleChangeCompanies}
                    />
                  </div>
                </div>

                <div className="form-row col-md-3">
                  <h4 className="header-title">{i18n.t("departments")}</h4>
                  {listCompanies.map((company) => (
                    <div
                      className="form-group col-md-12"
                      key={company.id}
                      style={{
                        display: userCompanies.find(
                          (uc) => uc.CompanyId === company.CompanyId
                        )
                          ? "block"
                          : "none",
                      }}
                    >
                      <label>{company.label}</label>
                      <Select
                        options={company.CompanyDepartments}
                        placeholder={`Seleciona os departamentos`}
                        isMulti={true}
                        // isDisabled={ disabled || !active }
                        getStyles="select2 form-control select2-multiple"
                        value={getUserCompanyDepartments(company.CompanyId)}
                        onChange={(e) =>
                          handleChangeDepartment(e, company.CompanyId)
                        }
                      />
                    </div>
                  ))}
                </div>
                <div
                  className="button-list mt-3 pull-right"
                  style={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    marginRight: 30,
                    marginBottom: 5,
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-outline-danger"
                    onClick={() => history.goBack()}
                  >
                    <i i className="mdi mdi-backup-restore"></i>
                    {i18n.t("getBack")}
                  </button>
                  <button
                    type="submit"
                    className="btn btn-outline-success"
                    disabled={!active}
                  >
                    <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                    {i18n.t("save")}
                  </button>
                </div>
              </form>
            </>
          ) : (
            <div className="area-loading">
              <CircularProgress />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
